import { useState, useCallback } from 'react';

/**
 * 로딩 상태 관리를 위한 커스텀 훅
 * 
 * @param initialLoading - 초기 로딩 상태 (기본값: false)
 * @returns {Object} 로딩 상태와 관련 함수들
 */
export const useLoading = (initialLoading: boolean = false) => {
  const [loading, setLoading] = useState(initialLoading);

  const startLoading = useCallback(() => {
    setLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setLoading(false);
  }, []);

  const withLoading = useCallback(async <T>(asyncFn: () => Promise<T>): Promise<T> => {
    try {
      startLoading();
      return await asyncFn();
    } finally {
      stopLoading();
    }
  }, [startLoading, stopLoading]);

  return {
    loading,
    setLoading,
    startLoading,
    stopLoading,
    withLoading,
  };
}; 